module.exports = __webpack_public_path__ + "static/media/book_bal_ae_jabreel_urdu_2.9c656ba5.jpg";